import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialerComponent } from '@app/_core/components/dialer/dialer.component';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { HubService } from '@app/pages/hubs/common/HubService';
import { Queue } from '@app/pages/queue/dialer/Queue';
import { Device } from '@twilio/voice-sdk';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
let sub: any;
let sub1: any;
let sub2: any;
let softPhoneInitializing = false;
@Component({
  selector: 'app-create-call',
  templateUrl: './create-call.component.html',
  styleUrl: './create-call.component.scss',
})
export class CreateCallComponent implements OnInit, OnChanges {
  public event: EventEmitter<any> = new EventEmitter();
  // @Input()
  // isTwilio: boolean;
  isTwilio: boolean = false;
  softPhone: boolean = false;
  selectedQuequId: number;
  queueList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];
  localStorageName = 'Queues-QueuesColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };
  innerHeight = 10;
  modalRef?: BsModalRef;
  selectedFilterByField: any = '';
  filterVal: any = '';
  cols: any;
  queueDialerType: any;
  automatedQueue = false;
  cloned: any;
  normalPriorityColors: string[] = ['#E99E1D', '#E99E1D', '#E99E1D', '#FFFFFF', '#FFFFFF'];
  lowPriorityColors: string[] = ['#2DB81F', '#2DB81F', '#FFFFFF', '#FFFFFF', '#FFFFFF'];
  highPriorityColors: string[] = ['#9B0411', '#9B0411', '#9B0411', '#9B0411', '#FFFFFF'];
  token: any;
  enableAnswerCallBtn: boolean = false;
  clientAbbreviation: any = '';
  selectedQueueId: any;
  callTimer: any;
  inboundCallDetails: any;
  twilioOptions: any;
  device: any;
  callId: any = '';
  connection: any;
  queueColumns: any;
  automatedInbound = false;
  pageRefresh = true;
  isDialerCancelled = false;
  inbound: any;
  newCallSnd = new Audio('https://common.cts-connect.com/Audio/ding-ding.ogg');
  ShowManualInboundcallAlert: boolean = false;
  IncomingCallAlerttext: any = '';
  countdownField: any = '';
  callAlertInterval: any = null;
  ActionItemID: any = '';
  QueueInteractionType: any;
  numberList: { name: string; value: string }[];
  numberTypeList: { type: string; name: string }[];
  phoneNumber: any;
  selectedNumber: any;
  IsSaveUserRecord: any;
  selectedCaseId: any;
  selectedUserID: any;
  selectedType: any;
  @Input() ReadOnly:boolean;
  isEnableAddNewNumber: boolean;
  
  // Phone validation modal properties
  showValidationModal: boolean = false;
  validationModalDisplay: string = 'none';
  validationErrorMessage: string = '';
  
  // Call disposition properties
  callDispositionOptions: { label: string; value: number }[] = [
    { label: '-Select One-', value: 0 },
    { label: 'No Answer', value: 1 },
    { label: 'Left Voicemail', value: 9 },
    { label: 'Wrong/Bad Number', value: 5 },
    { label: 'Line Busy', value: 21 },
    { label: 'Dropped Call', value: 23 }
  ];
  selectedCallDisposition: any = this.callDispositionOptions[0];
  callNotes: string = '';
  constructor(
    private securityService: SecurityService,
    private dialerService: DialerService,
    private tmQueueService: TmQueueService,
    private webStorage: WebStorageService,
    private queueServices: QueuesService,
    private modalService: BsModalService,
    private utils: Utils,
    private router: Router,
    private appService: AppService,
    private route: ActivatedRoute,
    private headerComponent: HeaderComponent,
    private hubService: HubService,
    private confirmDialogComponent: ConfirmDialogComponent,
    private mainController: MainControllerComponent,
    private dialerComponent: DialerComponent,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.appService.selectedQueueId.subscribe(value => {
     // console.log('selectedQueueId', value);
      if (value) {
        this.selectedQuequId = value;
      }
    });
    this.hubService.InboundCallEvents.subscribe((value: any) => {
      if (value && (value.eventName == 'OUTBOUND_CALL' || value.eventName == 'INBOUND_CALL')) {
        //console.log('outbound inbound call received', value.data);
        // _userDetails = value.data;
       // this.eInboundCallHandler(value.data);
      } else if (value && value.eventName == 'CALL_Ended') {
        // _userDetails = value.data;
        //console.log('outbound CALL_Ended received', value.data);
        this.eRealTimeCallEndedHandler(value.data);
      } else if (value && value.eventName == 'MESSAGE_RECEIVED') {
        // _userDetails = value.data;
        //console.log('outbound message received', value.data);
        //this.softPhoneProcessMessage(value.data);
      } else if (value && value.eventName == 'SUBMIT_CALL') {
        // _userDetails = value.data;
        this.eSubmitHandler();
      }
    });
    this.appService.actionItemId.subscribe(value => {
      if(value)
      {
        const paramArr = value?.split('-');
        this.selectedCaseId = value.includes('R') ? paramArr[paramArr.length - 2] : paramArr[paramArr.length - 1];
        this.selectedUserID = value.includes('R') ? paramArr[paramArr.length - 3] : paramArr[paramArr.length - 2];
      }
    });
  }
  ngOnChanges() {
   // console.log(this.isTwilio);
  }
  ngOnInit() {
   // console.log(this.ReadOnly,'read call lock');
    
    this.isTwilio = this.securityService.validateGrant('Twilio');
   // console.log(this.isTwilio);
    this.appService.selectedQueueType.subscribe((type: any) => {
      if (type == 'Search') {
        this.queueServices.isTaskMenuQueueSelected.subscribe((value: any) => {
          if (value.queueType == 'Search' && !this.GetIsPageLoadCompleted()) {
            //if (value) {
            this.pageRefresh = value.pageRefresh;
            //}
            //else {
            // this.isPageInitCompleted = true;
            this.SetIsPageLoadCompleted(value.isPageInitCompleted);
            // this.SetIsPageLoadCompleted = value.SetIsPageLoadCompleted;
            //}
            if (this.pageRefresh && !this.GetIsPageLoadCompleted()) {
              this.isDialerCancelled = false;
              this.SetDialerCancelledStatus(false);
              this.doPageInit();
              // this.isPageInitCompleted = true;
              this.SetIsPageLoadCompleted(true);
              this.pageRefresh = false;
              // this.queueServices.setTaskMenuQueueSelected(false);
            }
          }
        });
        if (this.pageRefresh && !this.GetIsPageLoadCompleted()) this.doPageInit();
        this.setPhoneNumber('Search', null);
        this.setNumberType();
      } else {
        //this.queueServices.getUserDetails(this.selectedCaseId, this.selectedUserID).subscribe(data => {
        //  this.setPhoneNumber('Outbound', data.Response.Data);
        //  this.setNumberType();
        //  this.queueServices.setSelectedSearchRecord(data.Response.Data);
        //});
      }
    });

      this.appService.CaseUserDetail.subscribe((data: any) => {
          if (data != null) {
              console.log('create call compoenent , CaseUserDetail')
              this.setPhoneNumber('Outbound', data);
              this.setNumberType();
              this.queueServices.setSelectedSearchRecord(data);
          }
      });
  }
  Predictiveclose = function (): void {
   // console.log('Predictive Close Called');
    window.clearTimeout(this.checkConnectedTimer);
    clearTimeout(this.waitingTimeout);
  };
  GetIsPageLoadCompleted() {
    const p1 = this.queueServices.getIsPageLoadCompleted();
    return p1;
  }
  /*setUserStatus(statusId, queueId) {
    this.tmQueueService.setUserStatus(statusId, queueId).subscribe(data => {
      //console.log("setUserStatus response", data);
    });
  }*/
  releaseLocks() {
    this.tmQueueService.releaseLocks().subscribe(data => {
      //console.log("releaseLocks response", data);
    });
  }
  rejectCall() {
    this.rejectInboundCall(this.queueServices.getCallID());
    this.dialerService.setcallEnded(true);
    this.ShowManualInboundcallAlert = false;
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
  }
  rejectInboundCall(_callId) {
    this.tmQueueService.rejectCall(_callId).subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
    this.dialerService.setIsTransferCallRejected(true);
  }
  getNextCallDetails(queueID) {
    this.ActionItemID = queueID + '-inbound_' + this.queueServices.getCallID();
  }
  answerInboundNextCall() {
    if (this.ActionItemID === '') {
      this.getNextCallDetails(this.selectedQueueId);
    }
    //this.setCurrentActionItem(this.selectedQueueId, this.ActionItemID);
    const data: any = {};
    data.dialerType = this.queueDialerType;
    data.navigateURL = this.ActionItemID;
    data.interactionType = this.QueueInteractionType;
    this.mainController.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);
    // Answer inbound call API
    this.tmQueueService
      .answerInboundCall(this.queueServices.getCallID(), this.queueServices.getselectedQueueId())
      .subscribe(data => {
       // console.log('answerInboundCall response', data);
        this.dialerService.setShowDialer(true);
        this.dialerService.setPhoneNo(data.Response.Data.PhoneNumber); // for testing
        this.dialerService.setCallConnected(true); // Show timer
        this.appService.setUserStatus(5, this.selectedQueueId);
        this.appService.setActionItemId(
          this.selectedQueueId + '-' + data.Response.Data.UserID + '-' + data.Response.Data.CaseID
        );
        this.setCurrentCallee(data.Response.Data.UserID);
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
      });
  }
  setCurrentActionItem(queueId, ActionItemID) {
    this.tmQueueService.setCurrentActionItem(queueId, ActionItemID).subscribe(data => {
      //console.log("setCurrentActionItem response", data);
      //this.dialerService.setShowDialer(true);
      let EnableAICaseNotesTemplate = data.Response.Data?.EnableAICaseNotesTemplate || false;
      this.appService.setEnableAICaseNotesTemplate(EnableAICaseNotesTemplate);
      //this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);
    });
  }
  eSubmitHandler() {
    // if (this.dialerType != "Manual" && this.dialerType != "External" && this.postCallTimeout && this.postCallTimeout > 0) {
    //     this.updatePostCallTimeout(false);
    //     clearInterval(this.postCallTimeoutInterval);
    //     //this.postCallTimeoutInterval = setInterval(this.updatePostCallTimeout, 1000);
    //     this.postCallTimeoutInterval = setTimeout(this.updatePostCallTimeout.bind(this), 1000);
    //}
    //this.goToNextCall(false, false, false);
  }
  SetDialerCancelledStatus(val) {
    this.dialerService.setDialerCancelledStatus(val);
  }
  inboundCallAlert = function (callDetails) {
    if (!this.postCall) {
      this.mainController.callEnded_phnctrl();
    }
    this.ShowManualInboundcallAlert = true;
    let Number = callDetails.find(i => i.key === 'number').value,
      name = Utils.cleanString(callDetails.find(i => i.key === 'name').value),
      queue = Utils.cleanString(callDetails.find(i => i.key === 'queue').value),
      _callId = callDetails.find(i => i.key === 'callID').value,
      queuedTime = this.convertServerDate(callDetails.find(i => i.key === 'queuedTime').value),
      now = 0,
      secondsRemaining = Math.floor(Math.min(60, 90 - (now - queuedTime) / 1000)),
      conference = callDetails.find(i => i.key === 'conference').value;

    this.callId = _callId;
   // this.queueServices.setCallID(_callId);
    this.newCallSnd.play();
    if (!conference) {
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
    }

    this.IncomingCallAlerttext =
      'Incoming ' +
      (conference ? 'conference with ' : 'call from ') +
      (Number == null ? '' : Number) +
      (name && name != '' ? ' - ' + name : '') +
      (queue && queue != '' ? ' (' + queue + ')' : '') +
      (this.postCall ? ' - Finish the current call to answer.' : '');

    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    this.callAlertInterval = setInterval(() => {
      secondsRemaining--;
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      if (secondsRemaining <= 0) {
        clearInterval(this.callAlertInterval);
        this.ShowManualInboundcallAlert = false;
        this.rejectInboundCall(this.queueServices.getCallID());
      }
    }, 1000);
  };
  convertServerDate = function (date) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  };
  eInboundCallHandler = function (callDetails) {
    this.inboundCallAlert(callDetails);
  };
  eRealTimeCallEndedHandler = function (e) {
    this.dialerService.setShowDialer(false);
    this.SetIsPageLoadCompleted(false);
    this.queueServices.setCaseDetails_ENABLECONTROLS(false);
  };
  softPhoneProcessMessage(msgBody) {
    if (msgBody == 'ping') {
      // clearTimeout(softPhonePingResponseTimeout);
      // softPhonePingTimeout = setTimeout(softPhoneMessagePing, softPhonePingDelay);
      // cls.log('Soft phone ping successful');
    } else {
      //parse the message as JSON
      try {
        let msg = msgBody;
        if (typeof msgBody === 'string') {
          msgBody = decodeURIComponent(decodeURIComponent(msgBody));
          msg = JSON.parse(msgBody);
        }
        this.inbound = msg.Inbound;
        const controller = msg.Controller;
        //theQueueID = msg.QueueID,
        //interactionID = msg.InteractionID;

        switch (controller) {
          case 'Dialog':
            this.Showdialer();
            break;
          case 'ExternalSystem':
            //var currStatus = im.AgentStatus.GetStatusByID(cls.profileStatus().getAgentStatus());
            //if (currStatus == im.AgentStatus.Statuses.ExternalAvailable) {
            //    cls.redirect(controller + '/' + queueID + '-' + (inbound ? 'inbound_' : '') + 'i' + interactionID, false, true);
            //}
            break;
        }
      } catch (e) {
        console.warn('Unexpected SIP message: ' + msgBody);
      }
    }
  }
  Showdialer() {
    this.dialerService.setDeviceReady(false);
    this.dialerService.setConnections(false);
    this.dialerService.setWaitingForInboundCall(false);
    this.dialerService.setShowDialer(true);
    this.dialerService.setCallConnected(true); // Show timer
    this.appService.setUserStatus(5, this.selectedQueueId);

    // Set user status 5
    //this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
  }
  setCurrentCallee(userID: any) {
    this.tmQueueService.setCurrentCallee(this.queueServices.getCallID(), userID).subscribe(data => {
      //console.log('setCurrentCallee response', data);
    });
  }
  setCurrentQueue(queueId) {
    this.tmQueueService.setCurrentQueue(queueId).subscribe(data => {
      //console.log("setCurrentQueue response", data);
    });
  }
  getInboundStatus(queueId, showLoader) {
    this.tmQueueService.getInboundStatus(queueId, showLoader).subscribe(data => {
      //console.log("getInboundStatus response", data);
    });
  }
  initializeSoftPhone1() {
    softPhoneInitializing = true;
    this.softPhone = true;
    navigator.mediaDevices.getUserMedia({ audio: true }).then(function () {});
    this.tmQueueService.GetTwilioToken().subscribe((response: any) => {
      //this.token = response.Response.Data.Token;
      this.token = response.Response.Data.Token;
      //console.log('Twilio Token', this.token);

      const twilioOptions: any = {
        debug: true,
        codecPreferences: ['opus', 'pcmu'],
        fakeLocalDTMF: true,
        enableRingingState: true,
        edge: ['ashburn', 'roaming'],
        closeProtection: true,
        // logLevel: 0,
        allowIncomingWhileBusy: true,
      };

      this.twilioOptions = twilioOptions;

      // Setup Twilio.Device
      const device = new Device(this.token, twilioOptions);

      this.addDeviceListeners(device);

      device.register();
    });
  }

  addDeviceListeners(device) {
    device.on('ready', () => {
     // console.log('Twilio.Device Ready!');
    });

    // Listen for the 'registered' event
    device.on('registered', () => {
      //console.log('The device is ready to receive calls.');
      this.dialerService.setDeviceReady(true);
    });

    device.on('incoming', conn => {
      this.connection = conn;
      //console.log('conn', conn);

      //console.log('Incoming connection from ' + conn.parameters.From);
      // this.dialerService.setConnections(false);
     // console.log(conn.parameters);

      //conn.accept();
      this.twilioClientInvited(conn);
      // this.dialerService.setPhoneNo(conn.parameters.From);
      this.dialerService.setStatusMessage('On Call (Active)');
    });

    device.on('error', (twilioError, call) => {
      //console.log('An error has occurred: ', twilioError);
    });

    device.on('connect', conn => {
    //  console.log('Successfully established call!');
    });

    device.on('disconnect', conn => {
     // console.log('Call ended.');
      device.disconnectAll();
    });

    device.on('tokenWillExpire', () => {
      this.tmQueueService.GetTwilioToken().subscribe((response: any) => {
        this.token = response.Response.Data.Token;
        this.device.updateToken(response.Response.Data.Token);
      });
    });

    this.device = device;
  }
  twilioClientInvited(conn) {
    let sipMessage = conn.customParameters.get('Message');
    sipMessage = typeof sipMessage != 'undefined' ? sipMessage : null;
    //if already on a call, then reject the incoming call
    // conn.reject();
    const conferenceID = conn.customParameters.get('Conference-ID');
    const CallSid = conn.parameters['CallSid'];
    const automatedCall = conn.customParameters.get('Automated-Call') == '"true"';
    const answerCall = callData => {
      //console.log('conn', conn);
      conn.accept();
      conn.on('accept', conn => {
        // Display case details page
        //console.log('Twilio.Device - Accept ' + conn.parameters.From);
        const twRemote = conn.getRemoteStream();
        if (typeof twRemote != 'undefined') {
          function twAddTrack(track) {
            //remoteStream.addTrack(track);
            //cls.dispatchEvent(MainController.MEDIATRACK_ADDED, track);
          }
          twRemote.getTracks().forEach(twAddTrack);
          twRemote.onaddtrack = function (receiver) {
            twAddTrack(receiver.track);
          };
        }

        // this.softPhoneCallAccepted(sipMessage, callData);
      });
      conn.on('error', error => {
       // console.log('Twilio.Device - Error (' + error.code + ') - ' + error.message);
        //softPhoneCallFailed(error.message);
      });

      conn.on('disconnect', conn => {
       // console.log('Twilio.Device - Disconnect');
        // this.dialerService.setShowDialer(false);
        // this.dialerService.setCallDisconnected(true);
      });

      conn.on('connect', conn => {
       // console.log('Successfully established call ! ');
        this.dialerService.setCallConnected(true);
        this.dialerService.setShowDialer(true);
      });
    };

    if (conferenceID) {
      //if it's an internal call, don't answer immediately.  Instead, query for the name of the agent that's calling
      this.tmQueueService.GetInternalCallInfo(conferenceID, CallSid).subscribe(data => {
        const agentInfo = data.Response.Data;
        conn.on('disconnect', conn => {
         // console.log('Twilio.Device - Disconnect');
          // this.dialerService.setShowDialer(false);
          // this.dialerService.setCallDisconnected(true);
        });
        this.confirmDialogComponent
          .confirmdialog(
            '',
            'Incoming internal call from ' + (agentInfo.FullName || 'unknown agent'),
            'Accept',
            'Decline'
          )
          .then(confirmed => console.log('User confirmed:', confirmed))
          .catch(() =>
            console.log(
              'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
            )
          );
        this.newCallSnd.play();
      });
    } else answerCall(null);
  }

  getVoicemailCountByStatus(agentID, status) {
    this.tmQueueService.getVoicemailCountByStatus(agentID, status).subscribe(data => {
      //console.log("getVoicemailCountByStatus response", data);
    });
  }

  getFailureDispositions() {
    this.tmQueueService.getFailureDispositions().subscribe(data => {
      //console.log("getFailureDispositions response", data);
    });
  }
  getExternalNumbersByActivity(queueId) {
    this.tmQueueService.getExternalNumbersByActivity(queueId).subscribe(data => {
      //console.log("GetExternalNumbersByActivity response", data);
    });
  }

  getUserStatus(queueId) {
    this.tmQueueService.getUserStatus(queueId).subscribe(data => {
      //console.log("getUserStatus response", data);
    });
  }
  doPageInit() {
    // this.isPageInitCompleted = true;
    // this.SetIsPageLoadCompleted(true);
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
   //console.log(this.clientAbbreviation);

    this.selectedQueueId = localStorage.getItem('qid');
    // this.isInboundCallConnected();
    //this.getQueueInfo(this.queueServices.getselectedQueueId());
    //this.releaseLocks();
   // console.log('Status updated here removed now');
    //   this.appService.setUserStatus(6, this.queueServices.getselectedQueueId());
    this.tmQueueService.getQueueColumns(this.selectedQueueId).subscribe(data => {
      // display data in grid
      // console.log("getQueueColumns response", data)
      this.queueColumns = data.Response.Data;
      this.headerComponent.getBasicAgentStats();
    });

    this.dialerService.callDisconnected.subscribe(value => {
      if (value) {
        // this.isPageInitCompleted = false;
        this.SetIsPageLoadCompleted(false);
        if (!this.dialerService.getIsTransferCallRejected()) {
          console.log('Twilio.Device - Reset');
          //this.mainController.disconnectTwilio();
        } else {
         // console.log('getIsTransferCallRejected - Reset');
          // this.mainController.resetSoftPhone();
        }
      }
    });
    this.dialerService.muteMic.subscribe(value => {
      this.mainController.muteUnmuteMic(value);
    });

    this.dialerService.resetTimer.subscribe((val: boolean) => {
      if (val) {
        clearInterval(this.callTimer);
      }
    });

    // this.dialerService.onHold.subscribe((val: boolean) => {
    //   if (val) {
    //     this.tmQueueService.holdCall(this.queueServices.getCallID(), true).subscribe(data => {
    //      // console.log(data);
    //     });
    //   }
    // });

    // this.dialerService.resumeCall.subscribe((val: boolean) => {
    //   if (val) {
    //     this.tmQueueService.resumeCall(this.queueServices.getCallID(), true, false, '').subscribe(data => {
    //      // console.log(data);
    //     });
    //   }
    // });
  }
  resetSoftPhone() {
    //if the softphone is already initializing, then just return
    if (this.device) {
      this.device?.disconnectAll();
      this.device?.unregister();
      this.device?.destroy();
      this.device = null;
     // console.log('resetsoftphone called');
    }
  }
  SetIsPageLoadCompleted(val) {
    this.queueServices.setIsPageLoadCompleted(val);
  }
  showPhoneMessaging = function (message: string): void {
    this.dialerService.setdialerMessage(message);
  };
  GetqueueDetails(queueId: any) {
    this.showPhoneMessaging('The soft phone is starting up. Please wait...');
    const Queueobj = new Queue(this.tmQueueService);
  }
  getQueueInfo1(queueId: any) {
    this.tmQueueService.getQueueInfo(queueId).subscribe(data => {
      const queueDialerType = data.Response.Data.DialerType;
      this.queueDialerType = queueDialerType;
      this.dialerService.setDeviceReady(true);
    });
  }

  getQueueInfo(queueId: any) {
    // // this.loaderService.display(true);
    //this.mainController.initializeSoftPhone();
    //this.mainController.GetqueueDetails(queueId, this.automatedQueue).then(res => {
    //  let det: any;
    //  det = res;
    //  this.queueDialerType = det.dialerType;
    //  this.QueueInteractionType = det.interactionType;
    //  this.dialerService.setDeviceReady(true);
    //  //this.setUserStatus(6, this.selectedQueueId);
    //    //this.appService.setUserStatus(6, queueId);
    //});
  }
  getInboundCalls(queueId, showLoader) {
    this.tmQueueService.getInboundCalls(queueId, showLoader).subscribe(data => {
      // button enable logic
      //console.log("getInboundCalls response", data);
      this.dialerService.setWaitingForInboundCall(false);
      //let inboundCallDetails = {"Response":{"Data":{"TotalItems":5,"TotalFilteredItems":5,"TotalFollowUp":0,"TotalApptReminder":0,"CaseUserRole":null,"Items":[{"UserID":0,"FirstName":null,"LastName":null,"FullName":"+918067665678","DateOfBirth":null,"EmailAddress":null,"JobTitle":null,"Industry":null,"JobLevel":null,"ActivityGroup":null,"Role":null,"Company":null,"CompanyType":null,"Address1":null,"Address2":null,"City":null,"Country":null,"State":null,"StateAbbrev":null,"Zip":null,"PostalCode":null,"Score":0,"VanityID":null,"ShortVanityID":null,"CrmUserID":null,"PromptResponses":null,"RequestType":null,"PhoneNumbers":null,"LastDisposition":null,"DispositionGroup":null,"Owner":null,"FollowUpDate":null,"FollowUpType":null,"LastCalled":null,"FirstResponseSourceName":null,"FirstResponseDate":null,"Department":null,"IsOverview":false,"ActionItemID":"69-inbound_CA11f1b44f7234ef3d622a56fe176f6d3f","Grouping":"Inbound","Priority":3,"LockingUserID":null,"WaitTime":10408,"CallType":"","CaseID":null,"CrmCaseID":null,"CaseStatus":null,"CasePriority":null,"CaseOpened":null,"CaseClosed":null,"SourceSystem":null,"SurveyResponses":null,"UserInfoResponses":null,"SearchableFieldResponses":null,"Cases":[],"UserRelationships":[]},{"UserID":0,"FirstName":null,"LastName":null,"FullName":"+918067665678","DateOfBirth":null,"EmailAddress":null,"JobTitle":null,"Industry":null,"JobLevel":null,"ActivityGroup":null,"Role":null,"Company":null,"CompanyType":null,"Address1":null,"Address2":null,"City":null,"Country":null,"State":null,"StateAbbrev":null,"Zip":null,"PostalCode":null,"Score":0,"VanityID":null,"ShortVanityID":null,"CrmUserID":null,"PromptResponses":null,"RequestType":null,"PhoneNumbers":null,"LastDisposition":null,"DispositionGroup":null,"Owner":null,"FollowUpDate":null,"FollowUpType":null,"LastCalled":null,"FirstResponseSourceName":null,"FirstResponseDate":null,"Department":null,"IsOverview":false,"ActionItemID":"69-inbound_CA079a02da981e065a3fd7f8ab0689f696","Grouping":"Inbound","Priority":3,"LockingUserID":null,"WaitTime":7842,"CallType":"","CaseID":null,"CrmCaseID":null,"CaseStatus":null,"CasePriority":null,"CaseOpened":null,"CaseClosed":null,"SourceSystem":null,"SurveyResponses":null,"UserInfoResponses":null,"SearchableFieldResponses":null,"Cases":[],"UserRelationships":[]},{"UserID":0,"FirstName":null,"LastName":null,"FullName":"+918067665678","DateOfBirth":null,"EmailAddress":null,"JobTitle":null,"Industry":null,"JobLevel":null,"ActivityGroup":null,"Role":null,"Company":null,"CompanyType":null,"Address1":null,"Address2":null,"City":null,"Country":null,"State":null,"StateAbbrev":null,"Zip":null,"PostalCode":null,"Score":0,"VanityID":null,"ShortVanityID":null,"CrmUserID":null,"PromptResponses":null,"RequestType":null,"PhoneNumbers":null,"LastDisposition":null,"DispositionGroup":null,"Owner":null,"FollowUpDate":null,"FollowUpType":null,"LastCalled":null,"FirstResponseSourceName":null,"FirstResponseDate":null,"Department":null,"IsOverview":false,"ActionItemID":"69-inbound_CA2c463d004461ee9a49f929b9d3ffb998","Grouping":"Inbound","Priority":3,"LockingUserID":null,"WaitTime":7566,"CallType":"","CaseID":null,"CrmCaseID":null,"CaseStatus":null,"CasePriority":null,"CaseOpened":null,"CaseClosed":null,"SourceSystem":null,"SurveyResponses":null,"UserInfoResponses":null,"SearchableFieldResponses":null,"Cases":[],"UserRelationships":[]},{"UserID":0,"FirstName":null,"LastName":null,"FullName":"+911246175678","DateOfBirth":null,"EmailAddress":null,"JobTitle":null,"Industry":null,"JobLevel":null,"ActivityGroup":null,"Role":null,"Company":null,"CompanyType":null,"Address1":null,"Address2":null,"City":null,"Country":null,"State":null,"StateAbbrev":null,"Zip":null,"PostalCode":null,"Score":0,"VanityID":null,"ShortVanityID":null,"CrmUserID":null,"PromptResponses":null,"RequestType":null,"PhoneNumbers":null,"LastDisposition":null,"DispositionGroup":null,"Owner":null,"FollowUpDate":null,"FollowUpType":null,"LastCalled":null,"FirstResponseSourceName":null,"FirstResponseDate":null,"Department":null,"IsOverview":false,"ActionItemID":"69-inbound_CAc12805440193895ae7aca79a1a427071","Grouping":"Inbound","Priority":3,"LockingUserID":null,"WaitTime":6597,"CallType":"","CaseID":null,"CrmCaseID":null,"CaseStatus":null,"CasePriority":null,"CaseOpened":null,"CaseClosed":null,"SourceSystem":null,"SurveyResponses":null,"UserInfoResponses":null,"SearchableFieldResponses":null,"Cases":[],"UserRelationships":[]},{"UserID":0,"FirstName":null,"LastName":null,"FullName":"+911246175678","DateOfBirth":null,"EmailAddress":null,"JobTitle":null,"Industry":null,"JobLevel":null,"ActivityGroup":null,"Role":null,"Company":null,"CompanyType":null,"Address1":null,"Address2":null,"City":null,"Country":null,"State":null,"StateAbbrev":null,"Zip":null,"PostalCode":null,"Score":0,"VanityID":null,"ShortVanityID":null,"CrmUserID":null,"PromptResponses":null,"RequestType":null,"PhoneNumbers":null,"LastDisposition":null,"DispositionGroup":null,"Owner":null,"FollowUpDate":null,"FollowUpType":null,"LastCalled":null,"FirstResponseSourceName":null,"FirstResponseDate":null,"Department":null,"IsOverview":false,"ActionItemID":"69-inbound_CA75184660abd6c552648f8ca97170e6af","Grouping":"Inbound","Priority":3,"LockingUserID":null,"WaitTime":5809,"CallType":"","CaseID":null,"CrmCaseID":null,"CaseStatus":null,"CasePriority":null,"CaseOpened":null,"CaseClosed":null,"SourceSystem":null,"SurveyResponses":null,"UserInfoResponses":null,"SearchableFieldResponses":null,"Cases":[],"UserRelationships":[]}]},"Status":1,"Message":null},"Status":1,"Message":null}
      this.inboundCallDetails = data.Response.Data.Items;
      if (data.Response.Data.TotalItems > 0) {
        //enable answer button
        this.enableAnswerCallBtn = true;
      }
    });
  }

  StartOutboundCall() {
    // Validate phone number if using add new number
    //if (this.isEnableAddNewNumber && !this.validatePhoneNumber()) {
    //  return; // Stop execution if validation fails
    //}
    
    this.dialerService.setResetTimer(true);
    this.dialerService.setPhoneNo(this.isEnableAddNewNumber ? this.phoneNumber : this.selectedNumber);
    this.dialerService.setIsEnableAddNewNumber(this.isEnableAddNewNumber);
    this.dialerService.setIsSaveUserRecord(this.IsSaveUserRecord);
    this.dialerService.setphoneNumberType(this.selectedType);
    this.dialerComponent.StartOutboundCall('CreateCall');
    this.queueServices.setOutboundRecordUserID(this.selectedUserID);
  }
  OnChangeSelectedNumber() {
    if (this.selectedNumber == 'Add') this.isEnableAddNewNumber = true;
    else this.isEnableAddNewNumber = false;
  }
  setNumberType() {
    this.numberTypeList = [
      { type: 'Business', name: 'Business' },
      { type: 'Personal', name: 'Personal' },
      { type: 'Mobile', name: 'Mobile' },
      { type: 'Fax', name: 'Fax' },
      { type: 'Pager', name: 'Pager' },
    ];
    this.selectedType = 'Business';
  }
  setPhoneNumber(type: any, selectedData: any) {
    this.numberList = [];
    if (type == 'Search') selectedData = this.queueServices.getSelectedSearchRecord();
    if (selectedData != null) {
      if (selectedData.PhoneNumbers != null && selectedData.PhoneNumbers.length > 0) {
        for (let i = 0; i < selectedData.PhoneNumbers.length; i++) {
          this.numberList.push({
            name: selectedData.PhoneNumbers[i].Type.substring(0, 1) + ':' + selectedData.PhoneNumbers[i].Number,
            value: selectedData.PhoneNumbers[i].Number,
          });
        }
        if (!this.selectedNumber) this.selectedNumber = selectedData?.PhoneNumbers[0].Number;
        // this.numberList.push({ name: 'Add New Number', value: 'Add' });
      }
      
    }
      this.numberList.push({ name: 'Add New Number', value: 'Add' });
  }

  toggleNumpad() {
    this.isEnableAddNewNumber = !this.isEnableAddNewNumber;
    if (this.isEnableAddNewNumber) {
      this.selectedNumber = 'Add';
    } else {
      this.selectedNumber = 'select';
    }
  }

  onSelectionChange(event: any) {
    this.selectedType = event.target.value;
    //console.log('Selected contact type:', this.selectedType);
  }

  validatePhoneNumber(): boolean {
    // Check if phone number is provided
    if (!this.phoneNumber) {
      this.showValidationError('Phone number is required.');
      return false;
    }

    // Skip validation for Fax and Pager types
    if (this.selectedType === 'Fax' || this.selectedType === 'Pager') {
      return true;
    }

    // Check minimum length of 12 characters
    if ((this.phoneNumber.includes("+") && this.phoneNumber.trim().length < 10)||
      (!this.phoneNumber.includes("+") && this.phoneNumber.trim().length < 10)
      || (this.phoneNumber.trim().length > 15)) {
      this.showValidationError('invalid phone number');
      return false;
    }

    return true;
  }

  showValidationError(message: string): void {
    this.validationErrorMessage = message;
    this.showValidationModal = true;
    this.validationModalDisplay = 'block';
  }

  closeValidationModal(): void {
    this.showValidationModal = false;
    this.validationModalDisplay = 'none';
    this.validationErrorMessage = '';
  }
    getValidationModalStatus() {
        return this.mainController.showValidationModal;
    }
    getvalidationErrorMessage() {
        return this.mainController.validationErrorMessage;
    }
    getDisplayvalidationModal() {
        return this.mainController.validationModalDisplay;
    }
  isValidDispositionSelected(): boolean {
    return this.selectedCallDisposition && this.selectedCallDisposition.value !== 0;
  }

  //submitFailure(): void {
  //  // Handle call failure submission with selected disposition and notes
  //  console.log('disposition:', this.selectedCallDisposition.label, ' - ', this.selectedCallDisposition.value);
  //    console.log('notes:', this.callNotes);
  //    this.mainController.isSubmitfailurePopupdisplayed = false;
  //  let callID = this.queueServices.getCallID() || '';
  //  let activityID = this.ActionItemID || '';
  //    let interactionID = this.queueServices.getInteractionID();

  //    let enterRecorddet: any;
  //    try {
  //        if (this.mainController.getEnterRecord() != '') {
  //            enterRecorddet = new Date(this.mainController.getEnterRecord()).getTime();
  //        }
  //        //enterRecorddet= (this.mainController.getEnterRecord() != '') ? this.mainController.getEnterRecord().getTime() : ''
  //    } catch (e) { }

  //  this.appService.activityId.subscribe(value => {
  //    activityID = value;
  //  });

  //    this.tmQueueService.submitFailure(callID, this.selectedCallDisposition.value, activityID, this.callNotes, this.selectedUserID, enterRecorddet, interactionID).subscribe({
  //    next: (response) => {
  //      console.log('Call failure submitted successfully:', response);
  //      this.closeValidationModal();
  //      this.queueServices.SetDisableHeader(false);
  //      this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue']);
  //    },
  //    error: (error) => {
  //      console.error('Error submitting call failure:', error);
  //    }
  //  });
  //}

  isPhoneNumberAvailable(): boolean {
    // Check if using add new number and phone number is provided
    if (this.isEnableAddNewNumber) {
      return !!(this.phoneNumber && this.phoneNumber.trim() && this.phoneNumber.trim().length >= 10 && this.phoneNumber.trim().length <= 15);
    }
    
    // Check if a valid number is selected from dropdown (not 'select')
    return !!(this.selectedNumber && this.selectedNumber !== 'select');
  }
}
